<template>
  <div class="container" style="width: 1280px;">
    <div class="one">
      <div class="xinxi1" v-if="flag"><img src="../../static/img/p2.png"><a href="">已选专业</a></div>
      <div class="xinxi1" v-else style="font-size: 16px;">已选专业</div>
      <div>
        <div class="da" :class="{openclass:open}">
          <div class="xinxi" v-for="(item,index) in selectlist"><span>{{item.majorName}} </span>
            <img v-if="flag" src="../../static/img/cha.png" @click="del(index)">
          </div>
        </div>
        <div style="text-align: center;" v-if="selectlist.length!=0">
          <div @click="open=!open">
            <span style="font-size: 16px;color: #e63233;">已选专业({{selectlist.length}})</span>
            <img src="../../src/views/images/icon_xia.png">
          </div>
        </div>
      </div>
      <div class="btn btnconfirm" v-if="flag" @click="confirm">确认选择</div>
      <div class="update" v-if="!flag" @click="update"><img style="margin-right: 8px;" src="../../src/assets/img/bianji.png" alt=""><a>修改</a></div>
      <div class="btn btnclear" v-if="flag" @click="clear">重置</div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["selectlist", "flag"],
    components: {

    },
    data() {
      return {
        open: false
      };
    },
    computed: {},
    methods: {
      del(index) {
        this.$emit("del", index);
      },
      confirm() {
        this.$emit("confirm");
      },
      clear() {
        this.$emit("clear");
      },
      update() {
        this.$router.push('/zhiyuanList_zyselect')

      }
    },
    mounted() {},
  };
</script>
<style scoped>
  .btn {
    width: 90px;
    height: 30px;
    font-size: 16px;
    line-height: 15px;
    border-radius: 8px;
    margin-left: 8px;
    margin-right: 10px;
  }

  .btnconfirm {
    background-color: #e63233;
    color: #FFFFFF;
  }

  .btnclear {
    color: #666;
    border: 1px solid #666;
  }

  .da {
    display: flex;
    justify-content: row;
    flex-wrap: wrap;
    align-items: center;
    width: 1075px;
    height: 35px;
    overflow: hidden;
  }

  .openclass {
    height: auto;
    overflow: inherit;
  }

  .update {}

  .update a {
    color: #29A7E1;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
  }

  .one {
    margin-top: 10px;
    justify-content: left;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 10px;
    width: 100%;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
    border-radius: 5px;
    display: flex;
    padding-left: 20px;
    min-height: 87px;
  }

  .one span {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666;
  }

  /* .one span,.xinxi img {
  margin-right: 8px;
} */
  /* 设置个别宽度不是以下不是此范围的样式 */
  .container {
    width: 1280px;
  }

  .xinxi1 {
    margin-right: 8px;
    display: flex;
    align-items: center;
    width: 70px;

  }

  .xinxi1 a {
    padding-left: 9px;
    text-decoration: none;
    color: #29A7E1;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;

  }

  .xinxi img {
    width: 8px;
    height: 8px;
    margin-top: -3px;
  }

  .xinxi {
    padding: 0 5px 0 5px;
    width: auto;
    height: 25px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #29A7E1;
    opacity: 1;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    line-height: 25px;

  }

  .xinxi span {
    text-align: center;
    font-size: 14px;
    text-decoration: none;
    color: #29A7E1;
    font-family: PingFang SC;
    font-weight: 500;

  }
</style>



// WEBPACK FOOTER //
// src/components/vMassage1.vue